<!--编辑开户公司-->
<template>
    <el-form ref="form" label-width="100px" size="mini">
        <el-row>
            <el-col :xs="20" :sm="20">
                <el-form-item :label="msg('身份证正面')">
                    <div style="display:flex;">
                        <el-upload class="avatar-uploader" :action="uploadUrl"
                                :show-file-list="false"
                                :with-credentials="true"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :xs="20" :sm="20">
                <el-form-item :label="msg('身份证反面')">
                    <div style="display:flex;">
                        <el-upload class="avatar-uploader" :action="uploadUrl"
                                :show-file-list="false"
                                :with-credentials="true"
                                :on-success="handleAvatarSuccess1"
                                :before-upload="beforeAvatarUpload1">
                            <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        </div>
    </el-form>
</template>

<script>
export default {
    name: 'companyEdit',
    data(){
        return {
            uploadUrl: this.$kit.api.upload+"?type=card&press=0",
            userId:null,
            front:null,
            back:null,
        }
    },
    computed:{
      imageUrl:{
          get(){
              if(this.card.idCardFront){
                  return this.$kit.api.imgView+this.card.idCardFront;
              }
              return null;
          }
      },
      imageUrl1:{
          get(){
              if(this.card.idCardBack){
                  return this.$kit.api.imgView+this.card.idCardBack;
              }
              return null;
          }
      }
    },
    props:{
        card:Object
    },
    methods:{
        init(id){
            this.userId = id;
            this.front = this.card.idCardFront;
            this.back = this.card.idCardBack;
        },
        onSubmit(){
            console.log(this.front);
            console.log(this.back)
            if(!this.front || !this.back){
                this.$message(this.msg("请上传身份证照片"));
                return;
            }
            var _this = this;

            let user = {
                id:this.userId,
                idCardFront:this.front,
                idCardBack:this.back
            }
            this.$axios.post(this.$kit.api.user.updateIdCard, user)
            .then(function(result){
                if(result.status){
                    _this.$message(result.msg || _this.msg('更新成功'));
                    if(result.status){
                        _this.$emit("close-dg", true);
                    }
                }else{
                    _this.$message(result.msg || _this.msg('更新失败'));
                }
            });

        },
        handleAvatarSuccess(res, file,fileList) {
            if(res.status){
                this.front = res.data;
                this.card.idCardFront = res.data;
            }else{
                this.$message(res.msg || this.msg("上传失败"));
            }
        },
        beforeAvatarUpload(){
            return true;
        },
        handleAvatarSuccess1(res, file,fileList) {
            if(res.status){
                this.back = res.data;
                this.card.idCardBack = res.data;
            }else{
                this.$message(res.msg || this.msg("上传失败"));
            }
        },
        beforeAvatarUpload1(){
            return true;
        },
    }
}
</script>
<style lang="scss">
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
    .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>